import axios from 'axios'
import type { DocumentStatus } from '@/types/documents'

/**
 * A client document as the api reports it.
 *
 * `status` is the row's own scan state — a document is awaiting its scan from the moment its
 * record exists — so the caller renders the wording for what it is told rather than assuming
 * the file it has just sent can be read back.
 *
 * `origin` is the api's url for the file. Nothing here appends the session token to it any
 * more: a form previews the copy the browser is already holding, and a document resolved later
 * is fetched over the authenticated client like every other request.
 */
export interface Document {
  createdAt: string
  documentType: string | null
  mimeType: string
  name: string | null
  origin: string
  status: DocumentStatus
  uuid: string
}

export async function storeDocument(
  document: File,
  name: string | undefined,
  mimeType: string,
  documentType: string | null,
): Promise<Document> {
  const formData = new FormData()
  formData.append('document', document)
  formData.append('mimeType', mimeType)

  if (name !== undefined) {
    formData.append('name', name)
  }

  if (documentType !== null) {
    formData.append('documentType', documentType)
  }

  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  }

  const response = await axios.post('/api/client/documents', formData, config)

  return response.data.data
}

export async function deleteDocument(uuid: string): Promise<boolean> {
  const response = await axios.delete(`/api/client/documents/${uuid}`)

  return response.data.data
}
